import { Injectable, RendererFactory2, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {
  private renderer: Renderer2;
  private readonly KEY = 'dhs-dark-mode';

  private _dark$ = new BehaviorSubject<boolean>(false);
  isDark$ = this._dark$.asObservable();

  get isDark(): boolean { 
    return this._dark$.value; 
  }

  constructor(factory: RendererFactory2) {
    this.renderer = factory.createRenderer(null, null);
    const saved = localStorage.getItem(this.KEY);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.apply(saved !== null ? saved === 'true' : prefersDark);
  }

  toggle(): void { 
    this.apply(!this._dark$.value); 
  }

  private apply(dark: boolean): void {
    this._dark$.next(dark);
    localStorage.setItem(this.KEY, String(dark));
    if (dark) {
      this.renderer.addClass(document.body, 'dark-mode');
    } else {
      this.renderer.removeClass(document.body, 'dark-mode');
    }
  }
}